export const gatewayMonitorHelp = '请确保所选CProm实例，其已关联网关VPC下的CCE集群（该CCE集群已安装CProm Agent）';
